<template>
  <div>
    <b-input-group size="lg" class="mb-3 d-flex justify-content-start">
      <template #prepend>
        <b-input-group-text>
          <strong class="text-dark">
            {{ fieldLetterPrefix }}
          </strong>
        </b-input-group-text>
      </template>
      <AddressSearch
        ref="addresses"
        :order-place="orderPlace"
        :client-id="clientId"
        :load-user-addresses="!!clientId"
        class="order-form-addresses big"
        :disabled="isInputDisabled"
      ></AddressSearch>
      <b-input-group-append>
        <b-button size="lg" @click="resetPlace" variant="outline-danger" class="shadow-none">
          <b-icon icon="x"></b-icon>
        </b-button>
      </b-input-group-append>
      <b-input-group-append>
        <b-button size="lg" v-if="!inUpdate" @click="inUpdate = true" variant="outline-success" title="Modifica" class="shadow-none">
          <b-icon-pencil-square></b-icon-pencil-square>
        </b-button>
        <b-button size="lg" v-if="inUpdate" @click="inUpdate = false" variant="success" title="Salveaza" class="shadow-none">
          <b-icon-pencil-square></b-icon-pencil-square>
        </b-button>
      </b-input-group-append>
      <b-input-group-append v-if="index === 0">
        <b-button size="lg"  v-b-toggle.preluare-detalii variant="outline-success" v-shortkey.push="['arrowdown']"  class="shadow-none">
          <b-icon icon="chat-left-text"></b-icon>
        </b-button>
      </b-input-group-append>
      <b-input-group-append v-if="index !== 0">
        <b-button size="lg" @click="removePlace" v-b-toggle.preluare-detalii variant="outline-danger" class="shadow-none">
          <b-icon icon="trash"></b-icon>
        </b-button>
      </b-input-group-append>
      <b-input-group-append>
        <b-button size="lg" :disabled="disabled" @click="addNewPlace" v-if="isLast" v-b-toggle.preluare-detalii variant="outline-success" class="shadow-none">
          <b-icon icon="plus"></b-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
import _ from 'lodash'
import AddressSearch from '@/components/dashboard/Delivery/Orders/v2/AddressSearch'
import config from '@/config'

export default {
  name: 'OrderPlaceField',
  components: {
    AddressSearch
  },
  props: {
    orderPlace: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    isLast: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    client: {
      type: Object,
      default: null
    }
  },
  mounted () {
    if (this.index === 0) {
      this.$nextTick(() => {
        this.$refs.addresses.$refs.select.$refs.search.focus()
      })
    }
  },
  data () {
    return {
      inUpdate: false,
      searchResults: []
    }
  },
  computed: {
    fieldLetterPrefix () {
      return 'ABCDEFGHIGKLMNOPQRSTUVWXYZ'[this.index]
    },
    placeholder () {
      return this.index === 0 ? 'Adresa preluare' : 'Destinatie'
    },
    isSdkLoaded () {
      return this.$store.state.isGoogleApiLoaded
    },
    isInputDisabled () {
      return this.disabled && !this.inUpdate
    },
    searchInputProps () {
      const props = { class: 'form-control', style: 'width: 710px' }
      if (this.isInputDisabled) {
        props.disabled = 'disabled'
      }
      return props
    },
    clientId () {
      if (this.client && typeof this.client.id !== 'undefined') {
        return this.client.id
      }
      return undefined
    }
  },
  methods: {
    getOptionLabel (option) {
      if (typeof option === 'object') {
        return option.label
      }
      return '-'
    },
    onSearch (search) {
      if (search.length) {
        this.search = search
        this.apiSearch(search, this)
      }
    },
    apiSearch: _.debounce((search, vm) => {
      vm.$axios.get(config.addrApiUrl + '/places-search?input=' + search + '&language=ro&components=country:ro&locationbias=circle:25000@46.7697361,23.5825689')
        .then((response) => {
          vm.searchResults = response.data.predictions.map((item) => {
            return {
              id: item.place_id,
              label: item.description
            }
          })
        })
    }, 500),
    fetchPlaceDetails (item, placeName) {
      this.$axios.get(config.addrApiUrl + '/place-details?place_id=' + item.id + '&fields=geometry,formatted_address,address_component,name&language=ro')
        .then((response) => {
          this.placeChanged(response.data.result, item.id, item.label)
        })
    },
    placeChanged (place, placeId, placeName) {
      if (this.inUpdate) {
        this.$store.dispatch('dispatcherDashboard/updateOrderPlace', {
          orderPlace: {
            id: this.orderPlace.id,
            order_id: this.orderPlace.order_id,
            name: this._formatGooglePlaceName(place, placeName),
            lat: place.geometry.location.lat,
            long: place.geometry.location.lng,
            place_id: placeId
          }
        })
          .then(() => {
            this.changePlaceInOrder(place, placeId, placeName)
            this.$toasted.success('Adresa actualizata')
          })
          .catch(() => {
            this.$toasted.error('Adresa invalida')
          })
          .then(() => {
            this.inUpdate = false
          })
      } else {
        this.changePlaceInOrder(place, placeId, placeName)
      }
    },
    changePlaceInOrder (place, placeId, placeName) {
      this.orderPlace.name = this._formatGooglePlaceName(place, placeName)
      this.orderPlace.lat = place.geometry.location.lat
      this.orderPlace.long = place.geometry.location.lng
      this.orderPlace.place_id = placeId
    },
    _formatGooglePlaceName (place, placeName) {
      let isPremise = false
      let premise = ''
      let streetNumber = ''
      let isStreetNumber = false
      let street = ''
      let city = ''
      place.address_components.forEach((item) => {
        if (item.types.includes('premise')) {
          isPremise = true
          premise = item.long_name
        } else if (item.types.includes('street_number')) {
          streetNumber = item.long_name
          isStreetNumber = true
        } else if (item.types.includes('route')) {
          street = item.long_name
        } else if (item.types.includes('locality')) {
          city = item.long_name
        }
      })

      if (!isStreetNumber) {
        return placeName
      }

      const parts = []
      if (isPremise) {
        parts.push(premise)
      } else {
        parts.push(street + ' ' + streetNumber)
      }
      if (city) {
        parts.push(city)
      }
      return ((street + ' ' + streetNumber) === place.name ? '' : '(' + place.name + ') ') + parts.join(', ')
    },
    addNewPlace () {
      this.$store.commit('dispatcherDashboard/addNewPlaceToOrder')
    },
    removePlace () {
      this.$store.commit('dispatcherDashboard/removePlaceFromOrder', {
        index: this.index
      })
    },
    resetPlace () {
      this.orderPlace.name = ''
      this.orderPlace.lat = null
      this.orderPlace.long = null
      this.orderPlace.place_id = null
    }
  },
  watch: {
    inUpdate: function (value) {
      if (value === true) {
        try {
          const nameParts = this.orderPlace.name.split(') - ')
          if (nameParts.length > 1) {
            nameParts.shift()
          }
          this.orderPlace.name = nameParts.join(') - ')
        } catch (e) {}
      }
    }

  }
}
</script>

<style>
  #autosuggest-autosuggest__results {
    position: relative;
  }
  #autosuggest-autosuggest__results ul {
    position: absolute;
    z-index: 9999;
    background-color: #fff;
    width: 100%;
    list-style: none;
    padding: 0;
  }
  #autosuggest-autosuggest__results ul li.autosuggest__results-item {
    border: 1px solid #ddd;
    margin-top: -1px;
    padding: 1px 5px;
  }
  #autosuggest-autosuggest__results ul li.autosuggest__results-item:hover {
    background-color: #eee;
    cursor: pointer;
  }

  .order-form-addresses .vs__dropdown-toggle {
    height: 38px;
  }
</style>
